<a #topOfPage id="topOfPage"></a>

<div class="page-content u10g-eoia-web-ag" page-content >

<prism-ui-grid-container>

    <prism-ui-grid breakpoint="900" gap="large" variant="equal" key-id="test-id">
 
    <prism-ui-copy
        font-size="xl"
        font-style="normal"
        font-weight="strong"
        key-id="1"
        line-height="medium"
        text-decoration="none"
        variant="default"
        class="tight-bordered-box top-border-radius"
      >
        <span>Overview</span>
      </prism-ui-copy>


    <prism-ui-copy
        font-size="md"
        font-style="normal"
        font-weight="regular"
        key-id="2"
        line-height="medium"
        text-decoration="none"
        variant="default"
        class="tight-bordered-box"
    >
    <div class="left-content">
      <prism-ui-icon
        icon-name="dollar-sign"
        key-id="test-key-id-2"
        size="2xl"
        spin="false"
        variant="default"
      ></prism-ui-icon>
      <span class="padding">Coverage</span>
    </div>
    <prism-ui-button
      button-width="content"
      key-id="view1"
      size="sm"
      variant="secondary"
      type="button"
      render-inline="true"
      (click)="goToCoverage()"
    >
      <span class="viewButtonPadding">View</span>
    </prism-ui-button>
    </prism-ui-copy>

    <prism-ui-copy
        font-size="md"
        font-style="normal"
        font-weight="regular"
        key-id="3"
        line-height="medium"
        text-decoration="none"
        variant="default"
        class="tight-bordered-box"
    >
    <div class="left-content">
      <prism-ui-icon
        icon-name="user"
        key-id="test-key-id-3"
        size="2xl"
        spin="false"
        variant="default"
      ></prism-ui-icon>
      <span class="padding">About Employee</span>
    </div>

      <prism-ui-button
            button-width="content"
            key-id="view-employee"
            size="sm"
            variant="secondary"
            type="button"
            render-inline="true"
            class="buttonPadding"
            (click)="goToEmployee()"
        >
        <span class="viewButtonPadding">View</span>

        </prism-ui-button>
    </prism-ui-copy>

    <prism-ui-copy
        font-size="md"
        font-style="normal"
        font-weight="regular"
        key-id="4"
        line-height="medium"
        text-decoration="none"
        variant="default"
        class="tight-bordered-box"
    >
    <div class="left-content">
      <prism-ui-icon
        icon-name="user"
        key-id="test-key-id-4"
        size="2xl"
        spin="false"
        variant="default"
      ></prism-ui-icon>
      <span class="padding">About Applicant</span>
    </div>

      <prism-ui-button
            button-width="content"
            key-id="view-applicant"
            size="sm"
            variant="secondary"
            type="button"
            render-inline="true"
            class="buttonPadding"
            (click)="goToApplicant()"
        >
        <span class="viewButtonPadding">View</span>

        </prism-ui-button>
    </prism-ui-copy>

    <prism-ui-copy
       font-size="md"
        font-style="normal"
        font-weight="regular"
        key-id="5"
        line-height="medium"
        text-decoration="none"
        variant="default"
        class="tight-bordered-box"
    >
    <div class="left-content">
      <prism-ui-icon
        icon-name="file-alt"
        key-id="test-key-id-5"
        size="2xl"
        spin="false"
        variant="default"
      ></prism-ui-icon>
      <span class="padding">Medical History Statement</span>
    </div>

      <prism-ui-button
            button-width="content"
            key-id="view-medical-history"
            size="sm"
            variant="secondary"
            type="button"
            render-inline="true"
            class="buttonPadding"
            (click)="goToMedicalHistory()"
        >
        <span class="viewButtonPadding">View</span>

        </prism-ui-button>
    </prism-ui-copy>

    <prism-ui-copy
        font-size="md"
        font-style="normal"
        font-weight="regular"
        key-id="6"
        line-height="medium"
        text-decoration="none"
        variant="default"
        class="bottom-border-radius"
    >
    <div class="left-content">
      <prism-ui-icon
        icon-name="hospital"
        key-id="test-key-id-6"
        size="2xl"
        spin="false"
        variant="default"
      ></prism-ui-icon>
      <span class="padding">Physician</span>
    </div>

      <prism-ui-button
            button-width="content"
            key-id="view-physician"
            size="sm"
            variant="secondary"
            type="button"
            render-inline="true"
            class="buttonPadding"
            (click)="goToPhysician()"
        >
        <span class="viewButtonPadding">View</span>

        </prism-ui-button>
    </prism-ui-copy>
  </prism-ui-grid>

</prism-ui-grid-container>

</div>
